module.exports = __webpack_public_path__ + "img/4606.49c15ec5.png";